// src/layouts/AuthLayout.jsx
import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import ThemeToggle from '../components/common/ThemeToggle';
import LanguageSwitcher from '../components/common/LanguageSwitcher';

export default function AuthLayout() {
    return (
        <div className="auth">
            <div className="auth__toggle" style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}>
                <LanguageSwitcher />
                <ThemeToggle />
            </div>

            <Link to="/" className="auth__brand">
                <FormattedMessage id="brand.name" />
                <span><FormattedMessage id="brand.suffix" /></span>
            </Link>

            <div className="auth__card">
                <Outlet />
            </div>
        </div>
    );
}